module.exports = __webpack_public_path__ + "img/crx-logo.29d9e670.png";